export default "__VITE_ASSET__b80503c8__"